export const descFields = [
    'outcomeDesc',
    'weightToLoseDesc',
    'allergiesDesc',
    'sugarDesc',
    'exerciseDesc',
    'restrictionsDesc',
    'currentDietDesc',
    'alcoholsDesc',
    'weekendMealsDesc',
    'cheatDesc',
    'dietSuccessDesc',
    'medicationsDesc',
    'surgeriesDesc',
    'breakfastDesc',
    'lunchDesc',
    'dinnerDesc',
    'snacksDesc',
    'sourceDesc',
];
